module.exports = __webpack_public_path__ + "static/media/staf-magazine.e233438a.png";